<template>
  <v-card class="v-login text-center">
    <v-card-title>
      <v-row justify="center">
        <LeadtributorCloudIconColor/>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <h1>{{$t('login.title')}}</h1>
    </v-card-subtitle>
    <div class="description">{{$t('login.description')}}</div>
    <v-text-field outlined v-model="loginComputed">
      <template v-slot:label>
        {{$t('login.email')}}
      </template>
    </v-text-field>
    <v-text-field outlined type="password" v-model="passwordComputed" :error-messages="value.failedLogin ? [$t('login.wrongPassword')] : []">
      <template v-slot:label>
        {{$t('login.password')}}
      </template>
    </v-text-field>
    <ButtonPrimaryDark @click="emitLoginEvent">
      <template v-slot:text>{{$t('login.login')}}</template>
    </ButtonPrimaryDark>
    <div class="small">{{$t('login.registerDescription')}}</div>
    <ButtonPrimaryLight @click="emitRegisterEvent">
      <template v-slot:text>{{$t('login.register')}}</template>
    </ButtonPrimaryLight>
    <v-divider></v-divider>
    <v-card-text class="px-0 pb-0">
      <v-row
        align="center"
        justify="space-around"
      >
        <slot></slot>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import LeadtributorCloudIconColor from '@/components/icons/LeadtributorCloudIconColor'
import ButtonPrimaryDark from '@/components/buttons/templates/ButtonPrimary'
import ButtonPrimaryLight from '@/components/buttons/templates/ButtonSecondary'
import { computed } from '@vue/composition-api'

export default {
  name: 'LoginComponent',
  props: {
    value:{
      type: Object,
      default: function () {
        return {
          login: '',
          password: '',
          failedLogin: false
        }
      }
    }
  },
  components: {
    ButtonPrimaryLight,
    ButtonPrimaryDark,
    LeadtributorCloudIconColor
  },
  setup (props, { emit }) {
    const loginComputed = computed({
      get: () => props.value.login,
      set: (login) => {
        let value = props.value
        value.login = login
        value.failedLogin = false
        emit('input', value)
      }
    })
    const passwordComputed = computed({
      get: () => props.value.password,
      set: (password) => {
        let value = props.value
        value.password = password
        value.failedLogin = false
        emit('input', value)
      }
    })

    function emitLoginEvent () {
      emit('login', props.value)
    }

    function emitRegisterEvent () {
      emit('register', props.value)
    }

    return {
      loginComputed,
      passwordComputed,
      emitLoginEvent,
      emitRegisterEvent
    }
  }
}
</script>

<style scoped lang="scss">
  .v-login {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    padding: 24px 32px 32px;
    margin: 0 auto;
    max-width: 338px;

    .v-card__subtitle {
      margin-top: 32px;
    }

    h1 {
      color: #3E4041;
      font-size: 30px;
      font-weight: 300;
      line-height: 38px;
    }

    .description {
      color: #8EA2A8;
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 32px;
    }

    .small {
      color: #8EA2A8;
      font-size: 14px;
      line-height: 17px;
      margin-top: 24px;
      margin-bottom: 16px;
    }

    .v-card__text {
      color: #8EA2A8;
      font-size: 14px;
      line-height: 17px;
    }
  }
</style>

<!-- global style to override framework styling  -->
<style lang="scss">
.v-login {
  .v-input {
    flex: none;

    &::after {
      display: none;
    }
  }

  .v-input__control {
    margin-bottom: 32px;
  }

  .v-label {
    font-size: 18px;
    line-height: 14px;
  }

  .v-button-secondary {
    border: 1px solid #707070 !important;
    box-shadow: none;
    margin-bottom: 32px;

    .v-btn__content {
      color: #3E4041;
    }

    &:hover {
      background: #707070 !important;

      .v-btn__content {
        color: #FFFFFF;
      }
    }
  }

  .v-divider {
    margin-top: auto;
  }

  .v-card__text {
    a {
      color: #8EA2A8;
      text-decoration: underline;
    }
  }
}
</style>
